import React from 'react';
import { User, Ruler, Scale, Activity } from 'lucide-react';

const PersonalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  activityLevels 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Пол */}
      <div className="col-span-full">
        <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Пол
        </div>
        <div className="grid grid-cols-2 gap-2">
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="gender"
              value="male"
              checked={formData.gender === 'male'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Мужской
            </span>
          </label>
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="gender"
              value="female"
              checked={formData.gender === 'female'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Женский
            </span>
          </label>
        </div>
        {errors.gender && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.gender}
          </p>
        )}
      </div>

      {/* Возраст */}
      <div>
        <label htmlFor="age" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <User className="w-4 h-4 mr-2 text-emerald-500" />
          Возраст (лет)
        </label>
        <input
          type="text"
          id="age"
          name="age"
          value={formData.age}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.age ? 'input-error' : ''}`}
          placeholder="Введите возраст"
        />
        {errors.age && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.age}
          </p>
        )}
      </div>

      {/* Вес */}
      <div>
        <label htmlFor="weight" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Scale className="w-4 h-4 mr-2 text-emerald-500" />
          Вес (кг)
        </label>
        <input
          type="text"
          id="weight"
          name="weight"
          value={formData.weight}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.weight ? 'input-error' : ''}`}
          placeholder="Введите вес"
        />
        {errors.weight && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.weight}
          </p>
        )}
      </div>

      {/* Рост */}
      <div>
        <label htmlFor="height" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Ruler className="w-4 h-4 mr-2 text-emerald-500" />
          Рост (см)
        </label>
        <input
          type="text"
          id="height"
          name="height"
          value={formData.height}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.height ? 'input-error' : ''}`}
          placeholder="Введите рост"
        />
        {errors.height && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.height}
          </p>
        )}
      </div>

      {/* Уровень активности */}
      <div className="col-span-full">
        <label htmlFor="activityLevel" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Activity className="w-4 h-4 mr-2 text-emerald-500" />
          Уровень физической активности
        </label>
        <select
          id="activityLevel"
          name="activityLevel"
          value={formData.activityLevel}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.activityLevel ? 'input-error' : ''}`}
        >
          <option value="" disabled>Выберите уровень активности</option>
          {activityLevels.map((level) => (
            <option key={level.id} value={level.id}>
              {level.name}
            </option>
          ))}
        </select>
        {errors.activityLevel && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.activityLevel}
          </p>
        )}
        {formData.activityLevel && (
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            {activityLevels.find(l => l.id === formData.activityLevel)?.description || ''}
          </p>
        )}
      </div>
      
      {/* Информационный блок о расчете BMR */}
      <div className="col-span-full mt-2 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg text-sm text-blue-700 dark:text-blue-300">
        <p className="font-medium mb-1">Как мы рассчитываем ваши потребности в калориях:</p>
        <p className="text-xs text-blue-600 dark:text-blue-400">
          Для расчета используется формула Миффлина-Сан Жеора, которая считается одной из самых точных для определения базового метаболизма (BMR). 
          Затем учитывается ваш уровень активности и цели по изменению веса.
        </p>
      </div>
    </div>
  );
};

export default PersonalParametersSection;